export const DESIGNATION_PAIRS: Record<string, string> = {
    Emporter: "Emporter",
    Drive: "Drive",
    Takeaway: "Drive-through",
    "Drive-through": "Takeaway",
};

export const DESIGNATION_CSS_MAP: Record<string, string> = {
    Restaurant: "fed_icn_restaurant",
    "En livraison": "fed_icn_delivery",
    "Sur place": "fed_icn_eatIn",
    Emporter: "fed_icn_takeOut",
    Drive: "fed_icn_Drive",
    "Retrait C&C": "fed_icn_WithdrawalC&C",
};

export const HIDDEN_MODES_OF_SALE = ["Retrait C&C", "Click and Collect"];

export const ERROR_TEXT_STYLE: React.CSSProperties = {
    width: "100%",
    marginTop: "0.25rem",
    fontSize: "80%",
    color: "#f46a6a",
};
